module.exports = __webpack_public_path__ + "images/embed/icons/gray_down_arrow.gif";